export default __webpack_public_path__ + "static/media/BoredApeYachtClub.3f390737.png";